module.exports = __webpack_public_path__ + "static/media/4.533bef2f.jpg";